export function RouteFallback() {
  return (
    <div
      className="flex min-h-[40vh] items-center justify-center text-text-secondary"
      role="status"
      aria-live="polite"
    >
      Loading…
    </div>
  );
}
